import { render, staticRenderFns } from "./WasteItemTypeTag.vue?vue&type=template&id=7ebc7b5e&scoped=true&"
import script from "./WasteItemTypeTag.vue?vue&type=script&lang=js&"
export * from "./WasteItemTypeTag.vue?vue&type=script&lang=js&"
import style0 from "./WasteItemTypeTag.vue?vue&type=style&index=0&id=7ebc7b5e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ebc7b5e",
  null
  
)

export default component.exports